export default "__VITE_ASSET__OYbWPqsv__"